import { useQuery } from '@tanstack/vue-query'

import { getPropertyOwnerVaspStatusCounts } from '../propertyOwnersEndpoints'
import { ownersQueryKeys } from '../propertyOwnersQueryKeys'

// PO VASP-onboarding queue counts (pending VASP approval). Drives the sidebar
// badge; VASP mutations invalidate the same key tree so it stays fresh.
export function usePropertyOwnerVaspStatusCountsQuery() {
  return useQuery({
    queryKey: ownersQueryKeys.vaspStatusCounts(),
    queryFn: getPropertyOwnerVaspStatusCounts,
  })
}
